<!--
 * @Author: DY
 * @Date: 2024-11-21 14:41:15
 * @LastEditTime: 2025-03-11 17:49:37
 * @Description: 退库入库审核【仓储管理】
 * @FilePath: \ShiMo_Mobile\src\views\storage\instockReturnApproval\index.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="instockReturnApproval commonListStyles">
            <van-nav-bar left-arrow left-text="应用" :style="`height: ${ $getNavHeight() }px;`" @click-left="swiperright">
                <template #title>
                    <div :class="{'active': listType == '1'}" @click="listSwitch('1')">
                        待审批
                    </div>
                    <div :class="{'active': listType == '2'}" @click="listSwitch('2')">
                        已审批
                    </div>
                </template>
            </van-nav-bar>
            <section>
                <van-search v-model="keyVal" placeholder="请输入搜索信息" @change="onRefresh"></van-search>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list v-model="isUpLoading" finished-text="没有更多了!" :finished="finished" @load="onLoad">
                        <ul class="list">
                            <li class="listItem" v-for="(item,index) in listData" :key="`item_${index}`">
                                <div class="engineeringInfo">
                                    <template v-for="s in StatusData">
                                        <span :style="`background: ${s.bg_color}`" :key="s.value" class="itemStatus" v-if="item.status === s.value">
                                            {{ s.name }}
                                        </span>
                                    </template>
                                    <h4 class="itemTitle">
                                        <span class="iconfont iconhetong">退库入库编号：{{ item.instock_number }}</span>
                                    </h4>
                                    <div class="itemContent">
                                        <p>
                                            <img src="@/assets/images/icons/icon_28@2x.png" alt="">
                                            <span>来源单据编号：{{ item.outstock_number }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_46@2x.png" alt="">
                                            <span>申请人：{{ item.apply_user_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_34@2x.png" alt="">
                                            <span>申请时间：{{ item.apply_time }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_47@2x.png" alt="">
                                            <span>仓库名称：{{ item.outstock_number }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_8@2x.png" alt="">
                                            <span>库管员：{{ item.storeman_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_7@2x.png" alt="">
                                            <span>入库时间：{{ item.InstockTime }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_10@2x.png" alt="">
                                            <span>备注：{{ item.Remarks }}</span>
                                        </p>
                                    </div>
                                    <div class="itemBtn itemBtns">
                                        <template v-if="[1, 2].includes(item.status)">
                                            <button @click="openWarehouseReceipt(item, 'edit')">
                                                编辑
                                            </button>
                                            <button @click="submitFun(item, 'edit')">
                                                提交
                                            </button>
                                        </template>
                                        <button @click="openWarehouseReceipt(item, 'see')" v-else>
                                            查看
                                        </button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
        </div>
    </v-touch>
</template>

<script>
import { mixin_list } from '@/assets/mixin/mixin_list';
export default {
    name: 'instock-return-approval',
    mixins: [mixin_list],
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'instock-return-approval');
        }
        next();
    },
    data() {
        return {
            tableCode: 'instock_return_pending',
            listType: '1',
            StatusData: [
                {
                    name: '待提交',
                    value: 0,
                    bg_color: '#F85B5B',
                },
                {
                    name: '待审核',
                    value: 1,
                    bg_color: '#F85B5B',
                },
                {
                    name: '待入库',
                    value: 2,
                    bg_color: '#F85B5B',
                },
                {
                    name: '已入库',
                    value: 3,
                    bg_color: '#F8985B',
                },
                {
                    name: '已作废',
                    value: 4,
                    bg_color: '#F8985B',
                },
            ],
        };
    },
    filters: {},
    computed: {},
    watch: {},
    activated() {
        if (this.$route.params.saveCallback) {
            this.onRefresh();
        }
    },
    created() {
        this.cacheKey = Math.floor(Math.random() * 1000000000000 + 1);
    },
    mounted() {},
    methods: {
        // 待办已办切换
        listSwitch(type) {
            if (type === '1') {
                this.tableCode = 'instock_return_pending';
            } else if (type === '2') {
                this.tableCode = 'instock_return_approved';
            }
            this.pageIndex = 0;
            this.listData = [];
            this.listType = type;
            this.finished = false;
            this.initPage();
        },
        async submitFun(item) {
            this.$dialog.confirm({
                message: '确认要提交吗？',
            }).then(async () => {
                const data = await this.getApplyData(item.id);
                let url = '';
                if (data.Status === 1) {
                    data.Status = 2;
                    url = '/interfaceApi/procurement/instock_return/instock_manager_save';
                } else if (data.Status === 2) {
                    data.Status = 3;
                    url = `/interfaceApi/procurement/instock_return/instock_storeman_save?instockId=${data.id}&status=3`;
                }
                const res = await this.saveApiData(url, data);
                if (res) {
                    this.$toast('提交成功！');
                    this.onRefresh();
                }
            });
        },
        openWarehouseReceipt(row, type) {
            const userId = this.$takeTokenParameters('Uid');
            this.$router.isBack = 2;
            let listType = 1;
            if (!row) {
                listType = 1;
            } else if (row.status === 1) {
                listType = 2;
            } else if (row.status === 2 && row.storeman_id === userId) {
                listType = 3;
            } else if (row.status === 3 && row.storeman_id === userId) {
                listType = 3;
            } else if (row.status === 2 && row.manager_id === userId) {
                listType = 2;
            } else if (row.status === 3 && row.manager_id === userId) {
                listType = 2;
            }
            this.$router.push({ name: 'instockReturnApprovalForm', params: { type, listType, data: row } });
        },
        // 获取详情
        getApplyData(id) {
            return this.$axios.$get(`/interfaceApi/procurement/instock_return/instock_single?id=${id}`, { defEx: true });
        },
        // 保存申请数据
        saveApiData(url, requestData) {
            return this.$axios.$post(url, requestData, { defEx: true });
        },
    },
};
</script>
<style lang="stylus">
.instockReturnApproval
    position relative
    .van-nav-bar
        .van-nav-bar__title
            div
                display inline-block
                padding 0 15rpx
                font-size 14rpx
                color rgba(240,240,240,0.7)
                transition 0.2s
                &.active
                    font-size 18rpx
                    color #fff
</style>
